/**
 * Invoice category summary — the per-category quantity roll-up shown in the
 * billing invoice-compare view, taken straight from the server's authoritative
 * category_subtotals aggregate so the client never re-derives (and disagrees
 * with) the persisted invoice.
 *
 * Contains:
 * - summarizeCategorySubtotals — category_subtotals[] → { [name]: { quantity } }
 *
 * Pure, dependency-free (kept out of the alias-blocked slice module so
 * node --test can import it directly). Returns plain JS — no JSX, no redux.
 */

/**
 * Per-category quantity summary for one invoice, keyed by category name, taken
 * from the server's category_subtotals aggregate (name + quantity per category,
 * in first-appearance order).
 *
 * @param {{ name: string|null, quantity: string }[]} [categorySubtotals]
 * @returns {Object<string, { quantity: number }>} Plain JS — no JSX.
 */
export const summarizeCategorySubtotals = (categorySubtotals = []) =>
  (categorySubtotals ?? []).reduce((summary, { name, quantity }) => {
    summary[name] = { quantity: parseFloat(quantity) };
    return summary;
  }, {});
